import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface BlAmendFormData {
  order: any;
  formStage: number;
}

@Injectable({
  providedIn: 'root'
})
export class BlAmendFormModalService {

  private selectedDataSubject = new BehaviorSubject<BlAmendFormData | null>(null);
  public selectedData$ = this.selectedDataSubject.asObservable();

  constructor() { }

  setSelectedData(order: any, formStage: number): void {
    this.selectedDataSubject.next({ order, formStage });
  }

  getSelectedData(): BlAmendFormData | null {
    return this.selectedDataSubject.value;
  }

  clearSelectedData(): void {
    this.selectedDataSubject.next(null);
  }
}

